export default __webpack_public_path__ + "static/Sitback logo-46e6d167235333e8902d2d8a1c240a62.png";